import { WEBSITE_LOCALES, WebsiteLocale } from '@/types/locales'

export const generateSEOAlternateUrls = (path: string) =>
  [
    ...WEBSITE_LOCALES.map((supportedLocale) => ({
      hreflang: supportedLocale,
      href: `${process.env.NEXT_PUBLIC_SITE_URL}/${supportedLocale}${path}`,
    })),
    { hreflang: 'x-default', href: `${process.env.NEXT_PUBLIC_SITE_URL}${path}` },
  ] as const

export const getCountryFromLocale = (locale: WebsiteLocale) => {
  return locale.split('-')[1].toUpperCase()
}

const countryToLocaleMap: Record<string, WebsiteLocale> = {
  GB: 'en-gb',
  US: 'en-us',
}

export const getLocaleFromCountry = (country: string) => {
  return countryToLocaleMap[country]
}

export const isInLocalisedPath = (pathname: string): boolean => {
  return WEBSITE_LOCALES.some((locale) => pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`)
}

export const isCurrentlyLocalized = (pathname: string, currentLocale: WebsiteLocale): boolean => {
  return pathname.startsWith(`/${currentLocale}/`) || pathname === `/${currentLocale}`
}

export const pathWithoutLocale = (pathname: string): string => {
  return pathname.replace(/^\/[a-z]{2}-[a-z]{2}\//, '')
}

export const hasAnyLocale = (path: string): boolean => {
  return WEBSITE_LOCALES.some((locale) => path.startsWith(`/${locale}/`) || path === `/${locale}`)
}

export const getPathWithoutAnyLocale = (path: string): string => {
  for (const locale of WEBSITE_LOCALES) {
    if (path.startsWith(`/${locale}/`) || path === `/${locale}`) {
      return path.replace(`/${locale}`, '')
    }
  }
  return path
}
